<template>
  <div>
    <sys-dialog-full-screen
      v-model="DIALOG_COMPUTED"
      titulo="Lista de Fornecedores em Ressuprimento"
    >
      <template #titulo-parte-direita>
        <v-btn color="primary" small @click="exportarFornecedoresEmRessuprimento">
          <v-icon left>mdi-file-export</v-icon>
          exportar
        </v-btn>
      </template>

      <v-data-table
        :headers="HEADERS_COMPUTED"
        :items="desserts_tabela"
        height="calc(100vh - 180px)"
        :item-height="45"
        :item-class="itemClass"
        :search="pesquisar"
        class="table-full-screen"
        :items-per-page="-1"
        @click:row="clickRow($event)"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>
              <h5>Comprador(a): {{ comprador.nome }}</h5>
            </v-toolbar-title>

            <v-divider class="mx-4" inset vertical />

            <v-spacer />

            <v-text-field
              label="Pesquisa"
              append-icon="mdi-magnify"
              outlined
              dense
              clearable
              single-line
              hide-details
              v-model="pesquisar"
              v-lazy-input:debounce="500"
              style="max-width: 550px"
            />
          </v-toolbar>
        </template>

        <template #body.prepend>
          <tr>
            <td v-for="(header, key) in HEADERS_COMPUTED" :key="key" class="font-weight-bold">
              {{ TOTALIZADOR_COMPUTED[header.value] || '' }}
            </td>
          </tr>
        </template>

        <template #item.cotacao="{ item }">
          <v-badge color="white" overlap v-if="item.cotacao > 0">
            <template v-slot:badge>
              <h4 style="color: #000">
                {{ item.qtde_item_cotacao }}
              </h4>
            </template>
            <v-icon title="Compra em processo de Cotação">mdi-phone-log</v-icon>
          </v-badge>
        </template>

        <template #item.abc_venda="{ value }">{{ deParaClassificacaoCriticidade(value) }}</template>
        <template #item.faturamento_ultimos_tres_meses="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>
        <template #item.qtde_excesso="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>
        <template #item.estoque_parado="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>
        <template #item.total_ressuprir="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

        <template #item.icon_compra="{ item }">
          <v-btn icon @click="getFornComprador(item, 2)">
            <v-icon>{{ item.icon_compra }}</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </sys-dialog-full-screen>
  </div>
</template>

<script>
import ResponsiveHeight from "@/helpers/ResponsiveHeight.js";
import $axios from '@/api/api.js'
import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue'
import { mapGetters } from 'vuex'
export default {
  mixins: [ResponsiveHeight],
  components: { SysDialogFullScreen },
  props: {
    dialog: Boolean,
    desserts_tabela: Array,
    comprador: {
      type: Object
    }
  },
  model: {
    prop: 'dialog',
    event: 'change-dialog'
  },
  data: () => ({
    pesquisar: '',
    selectedId: -1,
    headers_tabela: [
      { text: "Grupo", value: "nome_grupo" },
      { text: "Código", value: "id" },
      { text: "Razão social", value: "razao_social" },
      { text: "Data da Últ. Análise", value: "data_ultima_analise" },
      { text: "Qtde dias da Últ. Análise", value: "qtde_dias_ultima_analise" },
      { text: "Cotação", value: "cotacao", sortable: false },
      { text: "Dias em Cotação", value: "dias_em_cotacao" },
      { text: "Qtde. Produtos", value: "qtde_geral_itens" },
      { text: "Produtos Ok", value: "qtde_itens_ok" },
      { text: "Produtos Ressuprir", value: "qtde_itens_ressuprir" },
      { text: "Produtos com Venda Futura", value: "qtd_produtos_com_venda_futura" },
      { text: "Produtos Trânsito", value: "qtde_itens_transito" },
      { text: "ABC Venda", value: "abc_venda" },
      { text: "Faturamento Últimos 3 meses (R$ custo)", value: "faturamento_ultimos_tres_meses" },
      { text: "Excesso (R$ custo)", value: "qtde_excesso" },
      { text: "Estoque Parado há mais de 90 dias (R$ custo)", value: "estoque_parado" },
      { text: "Compra Prevista (Hoje)", value: "total_ressuprir" },
      { text: "", value: "icon_compra", sortable: false },
    ]
  }),
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      items: "tabela/getItems",
    }),
    DIALOG_COMPUTED: {
      get() { return this.dialog },
      set(valor) { this.$emit('change-dialog', valor) }
    },
    TOTALIZADOR_COMPUTED() {
      const qtde_geral_itens = this.sumField("qtde_geral_itens", this.desserts_tabela);
      const faturamento_ultimos_tres_meses = this.sumField("faturamento_ultimos_tres_meses", this.desserts_tabela);
      const qtde_excesso = this.sumField("qtde_excesso", this.desserts_tabela);
      const qtde_itens_ok = this.sumField("qtde_itens_ok", this.desserts_tabela);
      const qtde_itens_ressuprir = this.sumField("qtde_itens_ressuprir", this.desserts_tabela)
      const qtd_produtos_com_venda_futura = this.sumField("qtd_produtos_com_venda_futura", this.desserts_tabela)
      const qtde_itens_transito = this.sumField("qtde_itens_transito", this.desserts_tabela);
      const estoque_parado = this.sumField("estoque_parado", this.desserts_tabela);
      const total_ressuprir = this.sumField("total_ressuprir", this.desserts_tabela);

      return {
        nome_grupo: '#',
        id: '-',
        razao_social: 'TOTALIZADORES',
        data_ultima_analise: '-',
        qtde_dias_ultima_analise: '-',
        cotacao: '-',
        dias_em_cotacao: '-',
        qtde_geral_itens: this.Helpers.formatarValor(qtde_geral_itens),
        qtde_itens_ok: this.Helpers.formatarValor(qtde_itens_ok),
        qtde_itens_ressuprir: this.Helpers.formatarValor(qtde_itens_ressuprir),
        qtde_itens_transito: this.Helpers.formatarValor(qtde_itens_transito),
        qtd_produtos_com_venda_futura: this.Helpers.formatarValor(qtd_produtos_com_venda_futura),
        abc_venda: '-',
        faturamento_ultimos_tres_meses: this.Helpers.formatarValorMonetario(faturamento_ultimos_tres_meses),
        qtde_excesso: this.Helpers.formatarValorMonetario(qtde_excesso),
        estoque_parado: this.Helpers.formatarValorMonetario(estoque_parado),
        total_ressuprir: this.Helpers.formatarValorMonetario(total_ressuprir),
        icon_compra: null,
      }
    },
    HEADERS_COMPUTED() {
      return this.headers_tabela
        .filter(item => {
          return item.value !== 'qtd_produtos_com_venda_futura'
            || localStorage.existe_produtos_com_venda_futura === 'S';
        });
    }
  },
  methods: {
    clickRow(row) {
      if (row.id == '-') return;
      this.getFornComprador(row, 2);
      this.DIALOG_COMPUTED = false;
    },
    itemClass(i) {
      return [
        { 'font-bold': i.id == '-' },
        { 'cursor-pointer': i.id != '-' },
        { 'cursor-inactive': i.id == '-' },
      ]
    },
    deParaClassificacaoCriticidade(valor) {
      const tipo = {
        'Z - VITAL': 'A - VITAL',
        'Y - INTERMEDIARIO': 'B - INTERMEDIARIO',
        'X - ORDINARIO': 'C - ORDINARIO',
        '-': '-'
      };

      return tipo[valor];
    },
    exportarFornecedoresEmRessuprimento() {
      const params = `grupo/${this.grupoCompra}/comprador/${this.comprador.id}`;
      window.open(`${$axios.defaults.baseURL}/reports/fornecedores-em-ressuprimento/${params}`, "_blank");
    },
    sumField(key, dados = this.items.data || []) {
      return Object.values(dados).reduce((a, b) => {
        if (b.grupo_analise_fornecedores) {
          return parseFloat(a);
        }

        return parseFloat(a) + parseFloat(b[key] || 0);
      }, 0);
    },
    activerow(item) {
      this.selectedId = item.id;
      this.$set(item, "selected", true);
    },
    getFornComprador(item, tipo = 1) {
      this.activerow(item);

      if (item.grupo_analise_fornecedores) {
        localStorage.analiseGrupoFornecedores = 'S';
      } else {
        localStorage.analiseGrupoFornecedores = 'N';
      }

      this.Helpers.buscarCompraFornecedor(item, tipo);
    },
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.cursor-inactive {
  cursor: none;
}
</style>
